import { Helmet } from "react-helmet-async"
import { Breadcrumbs, searchToQuery } from "@sembark-travel/ui/router"
import {
	generatePath,
	useLocation,
	useParams,
} from "../../../../../../../../../../router-utils"
import { EditCabMetricsPricesSheet } from "../../../../../../../../../../DataDrive/Metric"

export default function CabMetricsEditPricesSheetByIdPage() {
	const location = useLocation()
	const { folderId, fileId, versionId } = useParams(
		"/data-drive/folders/:folderId/files/:fileId/versions/:versionId/edit/metric"
	)

	const query = searchToQuery<{
		file: string
		folder: string
	}>(location && location.search)

	const fileName = query["file"] || ""
	const folderName = query["folder"] || ""

	return (
		<>
			<Helmet>
				<title>Edit Transport Metrics Prices</title>
			</Helmet>
			<Breadcrumbs
				title={"Edit Transport Metrics Prices"}
				items={[
					[
						generatePath("/data-drive/folders/:folderId/files/:fileId", {
							folderId,
							fileId,
						}),
						`${folderName || ""}`,
					],
					[
						generatePath(
							"/data-drive/folders/:folderId/files/:fileId/versions/:versionId/view",
							{
								folderId,
								fileId,
								versionId,
							}
						),
						`${fileName || ""}`,
					],
				]}
			/>

			<EditCabMetricsPricesSheet
				metricFolderId={folderId}
				metricSheetId={fileId}
				metricVersionId={versionId}
			/>
		</>
	)
}
